/* About 页交互。目前只有 CTA 卡片里的图片轮播。
   单独一个文件而不是塞进 comu-sections.js：那个文件每页都加载，
   这段只有 About 用得到。 */
(function () {
  'use strict';

  function initCtaCarousel(root) {
    if (root.dataset.comuCtaBound === '1') return;
    root.dataset.comuCtaBound = '1';

    var imgs = root.querySelectorAll('.about-cta-carousel-img');
    var dots = root.querySelectorAll('.about-cta-carousel-dot');
    if (imgs.length === 0) return;

    var idx = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 0;

    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      Array.prototype.forEach.call(imgs, function (img, k) {
        img.classList.toggle('is-active', k === idx);
      });
      Array.prototype.forEach.call(dots, function (d, k) {
        d.classList.toggle('is-active', k === idx);
        d.setAttribute('aria-selected', k === idx ? 'true' : 'false');
      });
    }

    function start() {
      // 间隔设成 0 就是不自动切；prefers-reduced-motion 下也不自动切。
      if (!interval) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop();
      timer = setInterval(function () { show(idx + 1); }, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    Array.prototype.forEach.call(dots, function (d, k) {
      d.addEventListener('click', function () { show(k); start(); });
    });

    // 鼠标停留时暂停，和评价轮播保持一致的手感
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    show(0);
    start();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.forEach.call(
      container.querySelectorAll('[data-comu-cta-carousel]'),
      initCtaCarousel
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
